import React from "react";
import {
  ResponsiveContainer,
  ComposedChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Bar,
} from "recharts";

const data = [
  { name: "Monday", volume: 50, orders: 30, profit: 20, loss: 10 },
  { name: "Tuesday", volume: 60, orders: 40, profit: 25, loss: 15 },
  { name: "Wednesday", volume: 70, orders: 50, profit: 30, loss: 20 },
  { name: "Thursday", volume: 80, orders: 60, profit: 35, loss: 25 },
  { name: "Friday", volume: 90, orders: 70, profit: 40, loss: 30 },
  { name: "Saturday", volume: 100, orders: 80, profit: 45, loss: 35 },
  { name: "Sunday", volume: 110, orders: 90, profit: 50, loss: 40 },
];

const StackedBarChart = () => {
  return (
    <ResponsiveContainer width="100%" height={300}>
      <ComposedChart data={data} margin={{ top: 10, right: 10, left: 10, bottom: 15 }}>
        <CartesianGrid stroke="#d6d6d6" strokeDasharray="0 0" horizontal vertical={false} />
        <XAxis
          dataKey="name"
          tick={{ fontSize: 14, fill: "#999" }}
          label={{
            value: "Days of the Week",
            position: "insideLeft",
            offset: 0,
            style: { fontSize: "14px", fill: "#999" },
            dy: 20,
          }}
        />
        <YAxis
          tick={{ fontSize: 14, fill: "#999" }}
          label={{
            value: "Count (Units)",
            angle: -90,
            position: "insideBottom",
            offset: 40,
            style: { fontSize: "14px", fill: "#999" },
            dx: -20,
          }}
        />
        <Tooltip
          labelStyle={{ fontWeight: "bold", fontSize: "14px", color: "#000" }}
          itemStyle={{ color: "#999", fontSize: "14px" }}
          wrapperStyle={{ borderRadius: "5px", padding: "10px" }}
        />
        <Bar dataKey="volume" stackId="a" fill="#5662be" barSize={35} />
        <Bar dataKey="orders" stackId="a" fill="#7a86df" barSize={35} />
        <Bar dataKey="profit" stackId="a" fill="#b0b8f4" barSize={35} />
        <Bar dataKey="loss" stackId="a" fill="#f8e6bf" barSize={35} />
      </ComposedChart>
    </ResponsiveContainer>
  );
};

export default StackedBarChart; // Ensure it's exported
